var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7498 14.0001C11.8268 14.0001 12.6998 13.1271 12.6998 12.0501C12.6998 10.9731 11.8268 10.1001 10.7498 10.1001C9.67285 10.1001 8.7998 10.9731 8.7998 12.0501C8.7998 13.1271 9.67285 14.0001 10.7498 14.0001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95 9.44981C4.02696 9.44981 4.9 8.57676 4.9 7.49981C4.9 6.42285 4.02696 5.5498 2.95 5.5498C1.87304 5.5498 1 6.42285 1 7.49981C1 8.57676 1.87304 9.44981 2.95 9.44981Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63379 8.48145L9.07329 11.0684",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7498 4.9C11.8268 4.9 12.6998 4.02696 12.6998 2.95C12.6998 1.87304 11.8268 1 10.7498 1C9.67285 1 8.7998 1.87304 8.7998 2.95C8.7998 4.02696 9.67285 4.9 10.7498 4.9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06679 3.93164L4.63379 6.51864",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnShareWhite);
export default __webpack_public_path__ + "static/media/icn-share-white.529f228244224baa581f5b44684478f0.svg";
export { ForwardRef as ReactComponent };